import { IAdminPayment } from '../../../../api/adminPayments';
import { format, parseISO } from 'date-fns';
import { CheckBox } from '@wot/components';
import Chip from '../../../../components/Chip';
import { TableRowItemData } from '../../../../components/Table';

export default function TableRowItem({
  payment,
  selected,
  onSelect
}: {
  payment: IAdminPayment;
  selected: boolean;
  onSelect: (id: string, checked: boolean) => void;
}) {
  const ws = payment.workshop;
  const student = payment.studentData;

  return (
    <>
      <td className="w-12 px-4 py-2" onClick={(e) => e.stopPropagation()}>
        <CheckBox defaultValue={selected} onChange={(checked) => onSelect(payment._id, checked)} />
      </td>
      <TableRowItemData text={format(parseISO(payment.createdAt), 'dd/MM/yyyy')} />
      <TableRowItemData text={student?.name || '-'} />
      <TableRowItemData text={student?.email || '-'} />
      <TableRowItemData text={student?.phone || '-'} />
      <TableRowItemData text={ws?.title || '-'} />
      <TableRowItemData text={payment.amount != null ? `${payment.currency} ${payment.amount}` : '-'} />
      <TableRowItemData text={payment.paymentMethod || '-'} />
      <TableRowItemData
        component={
          <Chip
            state={
              payment.status === 'success' ? 'success' : payment.status === 'pending' ? 'warning' : 'error'
            }
          >
            <p className="text-sm font-semibold capitalize">{payment.status || '-'}</p>
          </Chip>
        }
      />
    </>
  );
}
